import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';


const setAnnouncementFormData = (state, { payload }) => {
  return {
    ...state,
    data: {
      ...state.data,
      ...payload
    },
  };
};
const clearAnnouncementFormData = (state) =>{
  return {
    ...state,
    data:{}
  }
}

const initialState = {};

export default createReducer(initialState, {
  [TYPES.SET_ANNOUNCEMENT_FORM_DATA]: setAnnouncementFormData,
  [TYPES.CLEAR_ANNOUNCEMENT_FORM_DATA]:clearAnnouncementFormData
});
